import React, { useState, useEffect, useRef } from 'react';

// PERFORMANCE: Monitor and display performance metrics
const PerformanceMonitor = ({ enabled = false, className = '' }) => {
  const [metrics, setMetrics] = useState({
    loadTime: 0,
    renderTime: 0,
    memoryUsage: 0,
    connectionType: 'unknown'
  });
  const startTime = useRef(performance.now());

  useEffect(() => {
    if (!enabled) return;

    const updateMetrics = () => {
      const now = performance.now();
      const loadTime = Math.round(now - startTime.current);
      
      // Get memory usage if available
      let memoryUsage = 0;
      if (performance.memory) {
        memoryUsage = Math.round(performance.memory.usedJSHeapSize / 1024 / 1024);
      }
      
      // Get connection type if available
      let connectionType = 'unknown';
      if (navigator.connection) {
        connectionType = navigator.connection.effectiveType || 'unknown';
      }

      setMetrics({
        loadTime,
        renderTime: Math.round(now - startTime.current),
        memoryUsage,
        connectionType
      });
    };

    // Update metrics every 2 seconds
    const interval = setInterval(updateMetrics, 2000);
    
    // Initial update
    updateMetrics();

    return () => clearInterval(interval);
  }, [enabled]);

  if (!enabled || process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className={`fixed bottom-4 right-4 bg-black/80 text-white text-xs p-2 rounded z-50 ${className}`}>
      <div className="space-y-1">
        <div>Load: {metrics.loadTime}ms</div>
        <div>Memory: {metrics.memoryUsage}MB</div>
        <div>Network: {metrics.connectionType}</div>
      </div>
    </div>
  );
};

export default PerformanceMonitor;